<template>
  <a-icon
    :icon="$options.consts.ICON.SPINNER"
    :original="true"
    :no-hover="true"
    :width="24"
    :height="24"
    class="button-spinner__wrapper"
  />
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'

export default {
  name: 'ButtonSpinner',
  components: { AIcon },
  consts: {
    ICON
  }
}
</script>

<style lang="scss" scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.button-spinner__wrapper {
  animation: spin 1.5s linear infinite;
}
</style>
